import { queryClient } from "~/repository";
import * as actionTypes from "~/store/action_types";

const calendarMiddleware = () => (next) => (action) => {
  const { type } = action;

  switch (type) {
    case actionTypes.ADD_CALENDAR_SUCCESS:
    case actionTypes.EDIT_CALENDAR_SUCCESS:
    case actionTypes.MOVE_CALENDAR_TO_TRASH_SUCCESS:
    case actionTypes.RESTORED_CALENDAR_FROM_TRASH_SUCCESS:
    case actionTypes.DELETE_CALENDAR_SUCCESS:
    case actionTypes.ADD_CALENDAR_EVENT_SUCCESS:
    case actionTypes.EDIT_CALENDAR_EVENT_SUCCESS:
    case actionTypes.MOVE_CALENDAR_EVENT_TO_TRASH_SUCCESS:
    case actionTypes.RESTORED_CALENDAR_EVENT_FROM_TRASH_SUCCESS:
    case actionTypes.DELETE_CALENDAR_EVENT_SUCCESS:
    case actionTypes.RESCHEDULE_ONLY_THIS_CALENDAR_EVENT_SUCCESS:
    case actionTypes.RESCHEDULE_THIS_AND_FUTURE_CALENDAR_EVENTS_SUCCESS:
    case actionTypes.RESCHEDULE_ALL_CALENDAR_EVENTS_SUCCESS:
    case actionTypes.RESCHEDULE_EXCEPTION_CALENDAR_EVENT_SUCCESS:
    case actionTypes.ADD_CALENDAR_EVENT_EXCLUDED_DATES_SUCCESS: {
      queryClient.invalidateQueries(["calendar-events"]);
      queryClient.invalidateQueries(["history-of-changes"]);
      return next(action);
    }
    default:
      return next(action);
  }
};

export default calendarMiddleware;
